import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import html2pdf from 'html2pdf.js';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
// helpers
import { setPageTitle } from 'helpers';
// components
import PassengersListForPrint from 'components/PassengersList/PassengersListForPrint';
// scss
import './PassengersPageForPrint.scss';

const PassengersPageForPrint = () => {
  const navigate = useNavigate();
  const passengersListData = JSON.parse(sessionStorage.getItem('appStatePassengers'));
  const { passengersList, calendarBtnText, totalPassengers, totalTickets,  } = passengersListData ?? {};
  const passengersPageLimit = 15;
  const passengersPages = Math.ceil(totalPassengers / passengersPageLimit) || 0;
  const calendarBtnTextNew = calendarBtnText?.replace("  ", " - ");
  const pdfRef = useRef();

  function getPassengersForPage(idx) {
    const startIdx = (idx - 1) * passengersPageLimit;
    const endIdx = idx * passengersPageLimit;
    return passengersList?.slice(startIdx, endIdx);
  }

  async function generatePDF() {
    const element = pdfRef.current;

    // Отримуємо кнопки, які потрібно приховати
    const buttons = document.querySelectorAll('.data-html2canvas-ignore');
    // Додаємо клас для приховування кнопок перед створенням PDF
    buttons?.forEach(button => button.classList.add('hide-for-pdf'));

    // Налаштування для html2pdf
    const opt = {
      margin: [0, 0, 0, 0],
      filename: 'tickets.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
    };

    // Генерація PDF і відкриття його у новій вкладці
    html2pdf()
      .from(element)
      .set(opt)
      .output('blob')
      .then(pdfBlob => {
        // Створюємо URL для відкриття у новій вкладці
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, '_blank');

        // Видаляємо клас, щоб повернути кнопки до видимості
        buttons?.forEach(button => button.classList.remove('hide-for-pdf'));
      });
  }

  useEffect(() => { setPageTitle("Згенерувати список пасажирів") }, []);
  useEffect(() => { if (passengersListData === null) navigate('/'); }, [passengersListData, navigate]);

  return (
    <>
      <section className="passengers">
        <div className="passengers__container container">
          <div className="tickets-content">
            <button className="tickets__btn--generatepdf ticket__btn--download" type="button" onClick={generatePDF} > Згенерувати PDF</button>

            <div className="print-passengers__list" ref={pdfRef}>
              {[...Array(passengersPages).keys()]?.map((_, idx) => {
                const page = idx + 1;

                return (
                  <div key={idx} className="print-passengers__page passengers--for-print" >
                    <PassengersListForPrint passengersList={getPassengersForPage(page)} page={page} passengersPages={passengersPages} pageLimit={passengersPageLimit} calendarBtnText={calendarBtnTextNew} totalPassengers={totalPassengers} totalTickets={totalTickets} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PassengersPageForPrint;
